export default __webpack_public_path__ + "static/media/producto.5bd39c39.jpg";